var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_187260",
    "data-name": "Group 187260",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.075,
    height: 20.474,
    viewBox: "0 0 23.075 20.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3300",
    "data-name": "Rectangle 3300",
    width: 23.075,
    height: 20.474,
    fill: "#7119bf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187259",
    "data-name": "Group 187259",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90484",
    "data-name": "Path 90484",
    d: "M0,2.4c.112-.234.137-.5.255-.732A2.709,2.709,0,0,1,2.78.011q7.367-.024,14.735,0a2.815,2.815,0,0,1,2.806,2.832q.012,4.4,0,8.81a.314.314,0,0,0,.2.336,4.372,4.372,0,0,1,2.509,3.47,4.449,4.449,0,0,1-3.771,4.973,4.354,4.354,0,0,1-4.105-1.58.442.442,0,0,0-.375-.184c-3.928.005-7.856-.018-11.784.015A2.9,2.9,0,0,1,.035,16.241c0-.019-.023-.035-.035-.053V2.4m8.557,15.55h5.792c.11,0,.256.048.157-.173a4.381,4.381,0,0,1-.261-2.745A4.474,4.474,0,0,1,19.4,11.619c.164.034.209,0,.207-.168-.007-.826,0-1.653,0-2.479a.331.331,0,0,0-.1-.26q-1.088-1.079-2.169-2.165c-.082-.083-.134-.1-.24-.023q-2.323,1.686-4.656,3.359c-.112.081-.121.123,0,.2.4.269.79.546,1.182.824.309.218.379.4.242.6s-.345.213-.663-.01Q9.684,9.037,6.167,6.565a.268.268,0,0,0-.4.01Q3.315,8.662.847,10.732a.355.355,0,0,0-.128.311q0,2.4,0,4.8a1.921,1.921,0,0,0,.068.487,2.106,2.106,0,0,0,2.091,1.615q2.839,0,5.679,0M19.565,7.786a.634.634,0,0,0,.037-.1c0-1.637.02-3.275-.005-4.912A2.074,2.074,0,0,0,17.508.727Q10.151.722,2.795.728A2.1,2.1,0,0,0,.722,2.812q-.005,3.425,0,6.85c0,.059-.039.135.048.188C.846,9.79.923,9.73,1,9.668q2.3-1.941,4.592-3.882c.287-.242.367-.244.67-.032q2.6,1.82,5.2,3.644a.305.305,0,0,0,.427.009c1.675-1.219,3.358-2.426,5.037-3.637.325-.234.429-.232.713.055.638.644,1.273,1.291,1.934,1.961M14.867,16A3.742,3.742,0,1,0,18.7,12.267,3.736,3.736,0,0,0,14.867,16",
    transform: "translate(0 0)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90485",
    "data-name": "Path 90485",
    d: "M149.4,44.983a2.374,2.374,0,1,1,2.342,2.38,2.359,2.359,0,0,1-2.342-2.38m.731,0a1.646,1.646,0,0,0,1.62,1.664A1.674,1.674,0,0,0,153.432,45a1.647,1.647,0,0,0-1.633-1.654,1.622,1.622,0,0,0-1.665,1.635",
    transform: "translate(-140.407 -40.056)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90486",
    "data-name": "Path 90486",
    d: "M279.152,229.768c-.275.282-.545.568-.826.844a.35.35,0,0,1-.577-.023.341.341,0,0,1,.051-.469c.492-.495.984-.989,1.483-1.478a.348.348,0,0,1,.568.007q.744.737,1.478,1.484a.339.339,0,0,1,.02.518.357.357,0,0,1-.521-.02c-.281-.279-.552-.569-.842-.87a.461.461,0,0,0-.054.293q0,1.2,0,2.41c0,.052,0,.105,0,.158a.381.381,0,0,1-.373.376.361.361,0,0,1-.346-.393c0-.653,0-1.306,0-1.959q0-.422,0-.845l-.058-.033",
    transform: "translate(-260.959 -214.74)",
    fill: "#7119bf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageIcon);
export default __webpack_public_path__ + "static/media/upload-image-icon.02517e146a55c600259efc3153d8a227.svg";
export { ForwardRef as ReactComponent };